/* 2026-09-23 - mobile colourway chips: rebind on a fresh lookup.
   The chip handler in boss-up-mobile-zoom.liquid captures the option <ul> in a
   closure when the rail is built. The theme REPLACES that <ul> on every variant
   change, so after the first switch every chip points at a detached element and
   taps do nothing until the rail happens to rebuild. Result: only the first one
   or two colour switches work. This listener runs in the capture phase, stops
   the stale handler, and finds the live option row at tap time. */
(function () {
  if (window.__buRailFix) return;
  window.__buRailFix = 1;

  function liveLists() {
    return document.querySelectorAll('main-product .product__details .variants_container ul.variant-options');
  }

  document.addEventListener('click', function (e) {
    var chip = e.target && e.target.closest && e.target.closest('button.bu-rail__chip');
    if (!chip) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var want = (chip.textContent || '').trim();
    if (!want) return;

    var lists = liveLists();
    var live = null;
    for (var i = 0; i < lists.length && !live; i++) {
      var lis = lists[i].querySelectorAll('li.option-item');
      for (var j = 0; j < lis.length; j++) {
        var val = lis[j].getAttribute('data-swatch');
        if (val === null) val = (lis[j].textContent || '').trim();
        if (val === want) { live = lis[j]; break; }
      }
    }

    if (live && live.isConnected) {
      live.click();
      var row = chip.parentElement;
      if (row) {
        var kids = row.children;
        for (var k = 0; k < kids.length; k++) kids[k].classList.remove('is-on');
      }
      chip.classList.add('is-on');
      var group = chip.closest('.bu-rail__group');
      var cur = group && group.querySelector('.bu-rail__label span');
      if (cur) cur.textContent = want;
    }
  }, true);
})();
